import { ReservedValues } from "@/constants/reservedValues";
import { t } from "@lingui/core/macro";
import type { GuiTimeZone } from "@mm/metx-workbench.meteomatics.com";
import { compile } from "ejs";
import type { GeoJSON } from "geojson";
import { DateTime } from "luxon";
import template from "./templates/lighting.ejs?raw";

const compiledTemplate = compile(template);

type LightningFeatureLike = {
  geometry: GeoJSON.Geometry;
  properties: GeoJSON.GeoJsonProperties;
};

export function createLightingTooltip(features: LightningFeatureLike[], timezone: GuiTimeZone) {
  const data = features.map((feature) => {
    const coordinates =
      feature?.geometry?.type === "Point" ? (feature.geometry.coordinates as [number, number]) : undefined;

    const strikeTime = feature?.properties
      ? DateTime.fromISO(feature.properties.stroke_time, {
          zone: timezone,
        }).toISO({ suppressMilliseconds: true })
      : t`No Information`;

    const currentValue = Number.parseInt(feature?.properties?.stroke_current);
    const isReservedCurrent = ReservedValues.includes(currentValue);

    const current = isReservedCurrent ? t`N/A` : currentValue;

    const polarity = isReservedCurrent ? t`N/A` : currentValue > 0 ? "+" : "-";

    const lightningTypeValue = Number.parseInt(feature?.properties?.lightning_type);
    const lightningType = ReservedValues.includes(lightningTypeValue)
      ? t`N/A`
      : lightningTypeValue === 1
        ? t`Cloud-to-Cloud`
        : t`Cloud-to-Ground`;

    const coordinate = coordinates ? `${coordinates?.[1]?.toFixed(4)}, ${coordinates?.[0]?.toFixed(4)}` : "-";

    return { coordinate, strikeTime, polarity, current, lightningType };
  });

  return compiledTemplate({ data });
}
